export default {

  SIGNED_IN(state) {
    state.google_is_signed_in = true;
  },

  RESET_EVENTS(state) {
    state.google_eventlist = [];
  },

  ADD_EVENT(state, event) {
    state.google_eventlist.push(event);
  },

  CALENDAR_AUTHORIZED(state, auth) {
    state.google_authorized = auth;
  },

  CALENDAR_AUTH_DATE(state, date) {
    state.google_auth_date = date;
  },
}
